import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import ReCAPTCHA from 'react-google-recaptcha';
import { AuthProvider, useAuth } from './AuthContext';
import AuthModal from './components/AuthModal';
import ResetPasswordPage from './components/ResetPasswordPage';
// ✨ ENHANCED DESIGN SYSTEM ENABLED ✨
// Using new Mathematical Playground design components
import Dashboard from './components/EnhancedDashboard';
import AdminDashboard from './components/AdminDashboard';
import DiagramAnalysisTool from './components/DiagramAnalysisTool';
import QuestionPoolManager from './components/QuestionPoolManager';
import EnhancedQuestionDisplay from './components/EnhancedQuestionDisplay';
import ProtectedRoute from './components/ProtectedRoute';
import GradeCollectionModal from './components/GradeCollectionModal';
import SubscriptionSuccess from './components/SubscriptionSuccess';
import SubscriptionCancel from './components/SubscriptionCancel';
import PracticeSessionLauncher from './components/PracticeSessionLauncher';
import PracticeSession from './components/EnhancedPracticeSession';
import SimpleLearningPathViewer from './components/SimpleLearningPathViewer';
import LearningPathPage from './components/LearningPathPage';
import TreeLearningPathViewer from './components/TreeLearningPathViewer';
import NewHomePage from './components/NewHomePage';
import SelectiveDashboard from './components/selective/SelectiveDashboard';
import { logRocketEvents } from './utils/logRocket';
import { initializeLogRocket } from './utils/logRocketInit';


// Ticket 5.1: Curriculum Map JSON Config (Per Year)
const CURRICULUM_MAPS = {
  'Year 3': {
    "Addition": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Subtraction": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Multiplication": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Division": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Shapes": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Counting": { "Easy": 3, "Medium": 3, "Hard": 4 }
  },
  'Year 4': {
    "Fractions": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Time": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Measurement": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Place Value": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Addition & Subtraction": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Money": { "Easy": 3, "Medium": 3, "Hard": 4 }
  },
  'Year 5': {
    "Fractions & Decimals": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Volume & Capacity": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Multiplication & Division": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Patterns & Algebra": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Angles": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Graphs": { "Easy": 3, "Medium": 3, "Hard": 4 }
  },
  'Year 6': {
    "Fractions": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Measurement": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Area": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Percentages": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Algebra": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Multiplication": { "Easy": 3, "Medium": 3, "Hard": 4 }
  },
  'Year 7': {
    "Integers": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Decimals": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Fractions": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Ratios": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Linear Equations": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Geometry": { "Easy": 3, "Medium": 3, "Hard": 4 }
  },
  'Year 8': {
    "Indices (Powers)": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Algebraic Expressions": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Pythagoras' Theorem": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Probability": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Linear Graphs": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Geometry": { "Easy": 3, "Medium": 3, "Hard": 4 }
  },
  'Year 9': {
    "Algebra": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Linear Equations": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Trigonometry": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Powers": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Quadratic Equations": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Statistics": { "Easy": 3, "Medium": 3, "Hard": 4 }
  },
  'Year 10': {
    "Quadratic Equations": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Simultaneous Equations": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Measurement": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Coordinate Geometry": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Surds & Indices": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Probability": { "Easy": 3, "Medium": 3, "Hard": 4 }
  },
  'Year 11': {
    "Functions & Graphs": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Polynomials": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Trigonometry": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Probability": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Statistics": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Sequences & Series": { "Easy": 3, "Medium": 3, "Hard": 4 }
  },
  'Year 12': {
    "Calculus": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Integration": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Limits": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Logarithms": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Vectors": { "Easy": 3, "Medium": 3, "Hard": 4 },
    "Complex Numbers": { "Easy": 3, "Medium": 3, "Hard": 4 }
  }
};

// Ticket 5.6: Admin/Test Logging System
class TestLogger {
  constructor() {
    this.logs = [];
    this.sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  log(type, data) {
    const logEntry = {
      timestamp: new Date().toISOString(),
      sessionId: this.sessionId,
      type,
      data
    };
    this.logs.push(logEntry);
    console.log(`[${type}]`, data);
    
    // Store in localStorage for persistence
    localStorage.setItem(`testLogs_${this.sessionId}`, JSON.stringify(this.logs));
  }

  logAIPrompt(prompt, yearLevel, curriculumMap) {
    this.log('AI_PROMPT', {
      prompt,
      yearLevel,
      curriculumMap,
      promptLength: prompt.length
    });
  }

  logAIResponse(questions, metadata) {
    this.log('AI_RESPONSE', {
      questionsGenerated: questions.length,
      metadata,
      questionsPreview: questions.slice(0, 3).map(q => ({
        topic: q.topic,
        difficulty: q.difficulty,
        questionPreview: q.question_text?.substring(0, 50) + '...'
      }))
    });
  }

  logStudentAnswer(questionIndex, question, selectedAnswer, isCorrect) {
    this.log('STUDENT_ANSWER', {
      questionIndex,
      topic: question.topic,
      difficulty: question.difficulty,
      selectedAnswer,
      correctAnswer: question.correct_answer,
      isCorrect,
      questionId: question.id || `q_${questionIndex}`
    });
  }

  logTestCompletion(totalQuestions, correctAnswers, skippedQuestions, testDuration) {
    this.log('TEST_COMPLETION', {
      totalQuestions,
      correctAnswers,
      skippedQuestions,
      testDuration,
      accuracy: (correctAnswers / totalQuestions) * 100,
      completionRate: ((totalQuestions - skippedQuestions) / totalQuestions) * 100
    });
  }

  getAllLogs() {
    return this.logs;
  }
}

// Global test logger instance
const testLogger = new TestLogger();

// Feature 4: Email Report Delivery Function with Resend
const sendTestReportEmails = async (studentData, testResults) => {
  try {
    // Check if running in browser (can't use Resend directly in frontend)
    // In production, this would be moved to backend
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    
    if (!BACKEND_URL) {
      console.log('Backend not configured, using demo mode');
      return await sendTestReportEmailsDemo(studentData, testResults);
    }

    // Calculate topic breakdown
    const topicBreakdown = {};
    Object.values(testResults.answers || {}).forEach(answer => {
      const topic = answer.question.topic;
      if (!topicBreakdown[topic]) {
        topicBreakdown[topic] = { correct: 0, total: 0 };
      }
      topicBreakdown[topic].total++;
      if (answer.correct) {
        topicBreakdown[topic].correct++;
      }
    });

    const topicsArray = Object.entries(topicBreakdown).map(([topic, stats]) => ({
      topic,
      correct: stats.correct,
      total: stats.total,
      percentage: Math.round((stats.correct / stats.total) * 100)
    }));

    // Prepare email data
    const emailData = {
      studentData,
      testResults: {
        ...testResults,
        topicsBreakdown: topicsArray,
        submissionTime: new Date().toISOString()
      }
    };

    // Send emails via backend
    const response = await fetch(`${BACKEND_URL}/api/send-test-emails`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(emailData)
    });

    if (response.ok) {
      console.log('Emails sent successfully via Resend');
      return {
        success: true,
        message: '✅ Your report has been emailed! Please check your inbox.'
      };
    } else {
      throw new Error('Failed to send emails via backend');
    }
    
  } catch (error) {
    console.error('Resend email sending error:', error);
    // Fallback to demo mode
    return await sendTestReportEmailsDemo(studentData, testResults);
  }
};

// Demo mode function (fallback when Resend not configured)
const sendTestReportEmailsDemo = async (studentData, testResults) => {
  try {
    const studentEmailData = {
      to: studentData.email,
      subject: 'Your Maths Campus Evaluation Report',
      body: `Hi ${studentData.firstName},

Thank you for completing the Maths Campus evaluation test!

Your Results:
- Score: ${testResults.correctAnswers}/${testResults.totalQuestions} (${testResults.scorePercentage}%)
- Year Level: ${studentData.yearLevel}
- Time Taken: ${Math.floor(testResults.testDuration / 60)} minutes

Keep practicing — your learning journey is just getting started!

– The Maths Campus Team`
    };

    const adminEmailData = {
      to: 'mathscampusonline@gmail.com',
      subject: 'New Student Evaluation Completed',
      body: `A new student has completed the evaluation test.

Student Name: ${studentData.firstName} ${studentData.lastName}
Email: ${studentData.email}
Year Level: ${studentData.yearLevel}
Submission Time: ${new Date().toISOString()}
Score: ${testResults.correctAnswers}/${testResults.totalQuestions} (${testResults.scorePercentage}%)

The performance report is ready for review.`
    };

    console.log('Demo Mode - Student Email:', studentEmailData);
    console.log('Demo Mode - Admin Email:', adminEmailData);
    
    return {
      success: true,
      message: '✅ Your report has been emailed! Please check your inbox. (Demo Mode)'
    };
    
  } catch (error) {
    console.error('Demo email error:', error);
    return {
      success: false,
      message: '⚠️ Report generated successfully, but email delivery failed.'
    };
  }
};

// Simplified AI Question Generator - now uses backend 3-tier fallback system
class AIQuestionGenerator {
  constructor(apiKey) {
    this.apiKey = apiKey; // Keep for compatibility but not used
  }

  buildPrompt(yearLevel, curriculumMap) {
    // Keep for logging purposes
    const totalQuestions = Object.values(curriculumMap).reduce((sum, difficulties) => 
      sum + Object.values(difficulties).reduce((diffSum, count) => diffSum + count, 0), 0
    );

    testLogger.logAIPrompt(`Backend 3-tier generation for ${yearLevel}`, yearLevel, curriculumMap);
    return `Backend generation: ${totalQuestions} questions for ${yearLevel}`;
  }

  async generateQuestions(yearLevel, curriculumMap) {
    try {
      const startTime = Date.now();
      console.log(`🚀 Starting 3-tier question generation for ${yearLevel}...`);
      
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      if (!BACKEND_URL) {
        throw new Error('Backend URL not configured');
      }

      console.log(`⏳ Calling backend generation endpoint...`);
      
      const response = await fetch(`${BACKEND_URL}/api/generate-questions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          year_level: yearLevel,
          curriculum_map: curriculumMap
        })
      });

      if (!response.ok) {
        throw new Error(`Backend generation failed: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      
      if (!result.success) {
        throw new Error('Backend generation was not successful');
      }

      const apiTime = Date.now() - startTime;
      console.log(`✅ Questions generated via ${result.generation_method} in ${apiTime}ms`);
      console.log(`📋 Message: ${result.message}`);
      
      // Process questions to match frontend format
      const processedQuestions = result.questions.map((q, index) => ({
        ...q,
        id: q.id || `generated_${Date.now()}_${index}`,
        correct_index: q.correct_index !== undefined ? q.correct_index : (q.options ? q.options.indexOf(q.correct_answer) : 0),
        generated_by: result.generation_method,
        timestamp: new Date().toISOString()
      }));

      // Log generation success
      testLogger.logAIResponse(processedQuestions, {
        originalCount: result.questions.length,
        processedCount: processedQuestions.length,
        yearLevel,
        method: result.generation_method
      });

      console.log(`🎯 Generated ${processedQuestions.length} questions successfully`);
      return processedQuestions;
      
    } catch (error) {
      console.error('Question Generation Error:', error);
      testLogger.log('GENERATION_ERROR', { 
        error: error.message, 
        yearLevel, 
        curriculumMap,
        timestamp: new Date().toISOString()
      });
      
      throw new Error(`Question generation failed: ${error.message}`);
    }
  }

  validateAndEnhanceQuestions(questions, curriculumMap) {
    // Questions are already validated by backend, just ensure format consistency
    return questions.filter(q => 
      q.question_text && 
      q.topic && 
      q.difficulty && 
      Array.isArray(q.options) && 
      q.options.length === 4 &&
      q.correct_index !== undefined
    );
  }

  // Deprecated - questions are now saved by backend automatically
  async saveQuestionsToPool(questions, yearLevel) {
    console.log('Questions automatically saved by backend during generation');
  }
}

// Maths Campus Landing Page Component with Authentication
const LandingPage = ({ onStartEvaluation, onStartSelectiveTest, isAuthenticated, onShowAuth }) => {
  const handleStartEvaluation = () => {
    if (isAuthenticated) {
      onStartEvaluation();
    } else {
      onShowAuth('login');
    }
  };

  const handleStartSelectiveTest = () => {
    if (isAuthenticated) {
      onStartSelectiveTest();
    } else {
      onShowAuth('login');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-blue-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <span className="text-2xl font-bold text-blue-600">📚 Maths Campus</span>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-4">
                <a href="#features" className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium">Features</a>
                <a href="#pricing" className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium">Pricing</a>
                <a href="#testimonials" className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium">Reviews</a>
                {isAuthenticated ? (
                  <button
                    onClick={() => onStartEvaluation()}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
                  >
                    Dashboard
                  </button>
                ) : (
                  <>
                    <button
                      onClick={() => onShowAuth('login')}
                      className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium"
                    >
                      Sign In
                    </button>
                    <button
                      onClick={() => onShowAuth('signup')}
                      className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
                    >
                      Sign Up
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-green-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left">
              <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
                Where Every Child Discovers Their
                <span className="text-blue-600"> Math Potential</span>
              </h1>
             <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              We start with a free evaluation that measures each child's current math skills and identifies their strengths and areas for improvement. Our detailed assessment helps you understand exactly where your child stands and what they need to work on next.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button
                  onClick={handleStartEvaluation}
                  className="bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:from-blue-700 hover:to-green-700 transition-all transform hover:scale-105 shadow-lg"
                >
                  🚀 {isAuthenticated ? 'Start Free Evaluation' : 'Sign Up & Start Evaluation'}
                </button>
                <a href ="https://youtu.be/d5d3YRVD2m8" target="_blank" rel="noopener noreferrer"> <button className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-xl text-lg font-semibold hover:bg-blue-600 hover:text-white transition-all">
                  🎥 Watch Demo
                </button> </a>
              </div>
              <div className="mt-8 flex items-center justify-center lg:justify-start space-x-6 text-sm text-gray-500">
                <div className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Years 3-12 Coverage
                </div>
                <div className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  AI-Powered Assessment
                </div>
                <div className="flex items-center">
                  <span className="text-green-500 mr-2">✓</span>
                  Curriculum Aligned
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <img 
                src="https://images.pexels.com/photos/8923956/pexels-photo-8923956.jpeg" 
                alt="Colorful math learning tools" 
                className="w-full max-w-lg rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>



      {/* Features Section */}
      <section id="features" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              🤖 AI-Powered Math Learning That Actually Works
            </h2>
           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our advanced AI assessment system evaluates each child's current skill level and identifies specific areas of strength and improvement, providing detailed insights for targeted learning.
          </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6 rounded-2xl bg-blue-50 hover:bg-blue-100 transition-colors">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🎯</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Smart Assessment</h3>
              <p className="text-gray-600">
                Our AI evaluates current math skills across all key topics, identifying strengths and areas for improvement.
              </p>
            </div>
            <div className="text-center p-6 rounded-2xl bg-green-50 hover:bg-green-100 transition-colors">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🧠</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Personalized Learning</h3>
              <p className="text-gray-600">
                AI-generated learning paths adapt in real-time based on progress, ensuring optimal challenge levels.
              </p>
            </div>
            <div className="text-center p-6 rounded-2xl bg-purple-50 hover:bg-purple-100 transition-colors">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">📊</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Progress Tracking</h3>
              <p className="text-gray-600">
                Detailed analytics show exactly how your child is improving, with insights for parents and teachers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Learning Journey */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://images.pexels.com/photos/6693301/pexels-photo-6693301.jpeg" 
                alt="Child learning with abacus" 
                className="w-full rounded-2xl shadow-lg"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                From Assessment to Mastery in 3 Simple Steps
              </h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm">1</div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Free AI Assessment</h3>
                    <p className="text-gray-600">Complete a comprehensive evaluation that identifies your child's current math level across all key topics.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center text-white font-bold text-sm">2</div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Personalized Learning Path</h3>
                    <p className="text-gray-600">Our AI creates a custom learning journey that targets areas for improvement while building on existing strengths.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm">3</div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Continuous Progress</h3>
                    <p className="text-gray-600">Watch your child's confidence and skills grow with adaptive lessons that evolve based on their progress.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Task 2: Waitlist Signup Section */}
      <WaitlistSignupSection />

      {/* Pricing Section */}
      <section id="pricing" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              💰 Choose Your Learning Journey
            </h2>
            <p className="text-xl text-gray-600">
              Start with our free assessment and comprehensive skill evaluation
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Free Tier */}
            <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-blue-300 transition-colors">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Free Assessments</h3>
                <div className="text-4xl font-bold text-gray-900 mb-2">$0</div>
                <p className="text-gray-600">Perfect for getting started</p>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <span className="text-green-500 mr-3">✓</span>
                  <span>3 Free math proficiency evaluation</span>
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-3">✓</span>
                  <span>AI-powered assessment report</span>
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-3">✓</span>
                  <span>Detailed skills breakdown</span>
                </li>
                <li className="flex items-center">
                  <span className="text-green-500 mr-3">✓</span>
                  <span>Years 3-12 coverage</span>
                </li>
              </ul>
              <button
                onClick={handleStartEvaluation}
                className="w-full bg-gray-900 text-white py-3 px-6 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
              >
                {isAuthenticated ? 'Start Free Assessment' : 'Sign Up & Start Assessment'}
              </button>
            </div>

            {/* Personal Learning Tier - Coming Soon */}
            <div className="bg-gray-100 border-2 border-gray-300 rounded-2xl p-8 relative opacity-75">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-600 mb-2">Personal Learning</h3>
                <div className="text-4xl font-bold text-gray-500 mb-2">$10<span className="text-lg text-gray-500">/month</span></div>
                <p className="text-gray-500">AI-personalized learning paths</p>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <span className="text-gray-400 mr-3">✓</span>
                  <span className="text-gray-500">Everything in Free Assessment</span>
                </li>
                <li className="flex items-center">
                  <span className="text-gray-400 mr-3">✓</span>
                  <span className="text-gray-500">Personalized learning path</span>
                </li>
                <li className="flex items-center">
                  <span className="text-gray-400 mr-3">✓</span>
                  <span className="text-gray-500">Daily practice problems</span>
                </li>
                <li className="flex items-center">
                  <span className="text-gray-400 mr-3">✓</span>
                  <span className="text-gray-500">Progress tracking</span>
                </li>
                <li className="flex items-center">
                  <span className="text-gray-400 mr-3">✓</span>
                  <span className="text-gray-500">Parent dashboard</span>
                </li>
                <li className="flex items-center">
                  <span className="text-gray-400 mr-3">✓</span>
                  <span className="text-gray-500">Email support</span>
                </li>
              </ul>
              <button disabled className="w-full bg-gray-400 text-white py-3 px-6 rounded-lg font-semibold cursor-not-allowed">
                Coming Soon
              </button>
            </div>

           {/* Family/Group Tier - Coming Soon */}
<div className="bg-gray-100 border-2 border-gray-300 rounded-2xl p-8 hover:border-gray-300 transition-colors opacity-75">
  
  <div className="text-center mb-8">
    <h3 className="text-2xl font-bold text-gray-600 mb-2">Family Plan</h3>
    <div className="text-4xl font-bold text-gray-500 mb-2">$15<span className="text-lg text-gray-500">/month</span></div>
    <p className="text-gray-500">For 2+ students</p>
  </div>
  <ul className="space-y-3 mb-8">
    <li className="flex items-center">
      <span className="text-gray-400 mr-3">✓</span>
      <span className="text-gray-500">Everything in Personal Learning</span>
    </li>
    <li className="flex items-center">
      <span className="text-gray-400 mr-3">✓</span>
      <span className="text-gray-500">Up to 4 student profiles</span>
    </li>
    <li className="flex items-center">
      <span className="text-gray-400 mr-3">✓</span>
      <span className="text-gray-500">Family progress dashboard</span>
    </li>
    <li className="flex items-center">
      <span className="text-gray-400 mr-3">✓</span>
      <span className="text-gray-500">Sibling comparison insights</span>
    </li>
    <li className="flex items-center">
      <span className="text-gray-400 mr-3">✓</span>
      <span className="text-gray-500">Priority support</span>
    </li>
  </ul>
  <button disabled className="w-full bg-gray-400 text-white py-3 px-6 rounded-lg font-semibold cursor-not-allowed">
    Coming Soon
  </button>
</div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section id="testimonials" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              💝 What Parents and Students Say
            </h2>
            <p className="text-xl text-gray-600">
              Real success stories from the Maths Campus community
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-2xl shadow-sm">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  ⭐⭐⭐⭐⭐
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "The Maths evaluation helped us identify exactly where my Year 8 daughter needed support. We discovered she was struggling with basic fraction concepts, which was affecting her algebra work. Now we know exactly what to focus on!"
              </p>
              <div className="flex items-center">
                <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold mr-3">
                  S
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Sarah Chen</div>
                  <div className="text-sm text-gray-600">Parent, Melbourne</div>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  ⭐⭐⭐⭐⭐
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "The assessment revealed my Year 5 son was actually ahead in some areas and behind in others. It helped us understand his true skill level and showed us exactly which foundational concepts needed work before moving to harder topics."
              </p>
              <div className="flex items-center">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center text-white font-bold mr-3">
                  M
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Michael Thompson</div>
                  <div className="text-sm text-gray-600">Parent, Sydney</div>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  ⭐⭐⭐⭐⭐
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "As a parent, I really appreciate how the Maths evaluation gives a clear picture of my child's strengths and weaknesses. It helped me understand exactly where they need support and gave me confidence that we're focusing on the right areas."
              </p>
              <div className="flex items-center">
                <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center text-white font-bold mr-3">
                  L
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Lisa Rodriguez</div>
                  <div className="text-sm text-gray-600">Parent, Sydney</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-green-600">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Unlock Your Child's Math Potential?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Start with our free AI-powered assessment and see exactly where your child stands in their math journey.
          </p>
          <button
            onClick={handleStartEvaluation}
            className="bg-white text-blue-600 px-8 py-4 rounded-xl text-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg"
          >
            🚀 {isAuthenticated ? 'Start Free Assessment Now' : 'Sign Up & Start Assessment'}
          </button>
          <p className="text-blue-100 mt-4 text-sm">
            No credit card required • Takes 45-60 minutes • Instant results
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center mb-4">
                <span className="text-2xl font-bold text-blue-400">📚 Maths Campus</span>
              </div>
              <p className="text-gray-300 mb-4">
                Where every child discovers their math potential through comprehensive skill assessment and evaluation.
              </p>
              <div className="flex space-x-4">
                <a href="mailto:mathscampusonline@gmail.com" className="text-gray-300 hover:text-white">📧 Email</a>
                <a href="tel:+1234567890" className="text-gray-300 hover:text-white">📞 Phone</a>
                <a href="mailto:mathscampusonline@gmail.com" className="text-gray-300 hover:text-white">💬 Chat</a>
              </div>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Product</h3>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-300 hover:text-white">Features</a></li>
                <li><a href="#pricing" className="text-gray-300 hover:text-white">Pricing</a></li>
                <li><a href="#" className="text-gray-300 hover:text-white">Curriculum</a></li>
                <li><a href="#" className="text-gray-300 hover:text-white">Support</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Legal</h3>
              <ul className="space-y-2">
                <li><a href="/privacy-policy.html" className="text-gray-300 hover:text-white" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
                <li><a href="/terms-of-service.html" className="text-gray-300 hover:text-white" target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
                <li><a href="/cookie-policy.html" className="text-gray-300 hover:text-white" target="_blank" rel="noopener noreferrer">Cookie Policy</a></li>
                <li><a href="mailto:mathscampusonline@gmail.com" className="text-gray-300 hover:text-white">Contact Us</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <p className="text-gray-300">
              © 2024 Maths Campus. All rights reserved. Made with ❤️ for better math education.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

// Task 2: Waitlist Signup Section Component
const WaitlistSignupSection = () => {
  const [formData, setFormData] = useState({
    email: '',
    first_name: '',
    last_name: '',
    year_level: '',
    interest_type: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const yearLevels = [
    'Year 3', 'Year 4', 'Year 5', 'Year 6', 'Year 7', 'Year 8',
    'Year 9', 'Year 10', 'Year 11', 'Year 12'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email) {
      alert('Email is required');
      return;
    }

    setIsSubmitting(true);
    
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      
      const response = await fetch(`${BACKEND_URL}/api/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          source: 'landing'
        })
      });

      if (response.ok) {
        setShowSuccess(true);
        setFormData({
          email: '',
          first_name: '',
          last_name: '',
          year_level: '',
          interest_type: ''
        });
        setTimeout(() => setShowSuccess(false), 5000);
      } else {
        throw new Error('Failed to join waitlist');
      }
    } catch (error) {
      console.error('Waitlist signup error:', error);
      alert('Failed to join waitlist. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-100 to-green-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              🚀 Coming Soon: Personalized Learning Path
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Your free evaluation is just the beginning.
              <br />
              Soon, you'll unlock AI-driven learning paths designed just for your child.
              <br />
              Join our waitlist and get early access + exclusive launch discounts.
            </p>
          </div>

          {showSuccess ? (
            <div className="text-center py-8">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">✅</span>
              </div>
              <h3 className="text-2xl font-bold text-green-600 mb-2">You're in!</h3>
              <p className="text-gray-600">We'll let you know when personalized learning launches.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="your.email@example.com"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Student's School Year
                  </label>
                  <select
                    value={formData.year_level}
                    onChange={(e) => setFormData({...formData, year_level: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">Select Year Level</option>
                    {yearLevels.map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    First Name
                  </label>
                  <input
                    type="text"
                    value={formData.first_name}
                    onChange={(e) => setFormData({...formData, first_name: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="First name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Last Name
                  </label>
                  <input
                    type="text"
                    value={formData.last_name}
                    onChange={(e) => setFormData({...formData, last_name: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Last name"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Interest Type
                </label>
                <div className="flex space-x-4">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value="Individual"
                      checked={formData.interest_type === 'Individual'}
                      onChange={(e) => setFormData({...formData, interest_type: e.target.value})}
                      className="mr-2"
                    />
                    Individual Learning
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value="Group"
                      checked={formData.interest_type === 'Group'}
                      onChange={(e) => setFormData({...formData, interest_type: e.target.value})}
                      className="mr-2"
                    />
                    Group Learning
                  </label>
                </div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting || !formData.email}
                className="w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-4 px-8 rounded-xl text-lg font-semibold hover:from-blue-700 hover:to-green-700 transition-all transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
              >
                {isSubmitting ? 'Joining Waitlist...' : 'Join the Waitlist'}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

// Welcome Screen Component with AI Enhancement Notice
const WelcomeScreen = ({ onStart }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50 flex items-center justify-center p-4">
      <div className="max-w-3xl w-full text-center">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          {/* Friendly Mascot Section */}
          <div className="mb-8">
            <div className="flex justify-center mb-6">
              <img 
                src="https://img.freepik.com/free-photo/3d-cartoon-math-objects-character_23-2151749726.jpg" 
                alt="Friendly Math Mascot" 
                className="w-32 h-32 md:w-40 md:h-40 rounded-full shadow-lg object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-full bg-gradient-to-br from-blue-400 to-purple-500 flex items-center justify-center text-6xl md:text-7xl" style={{display: 'none'}}>
                🤖
              </div>
            </div>
            
            <h1 className="text-4xl md:text-6xl font-bold text-blue-600 mb-4">
              🤖 Advanced Math Assessment
            </h1>
            
            {/* Enhanced Welcome Message */}
            <div className="bg-gradient-to-r from-yellow-100 to-orange-100 rounded-2xl p-6 mb-6">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">
                Hi there! Let's discover your math superpowers with our advanced assessment! ✨
              </h2>
              <p className="text-lg text-gray-700">
                Our advanced system will create a personalized test just for you, perfectly matched to your year level!
              </p>
            </div>
            
            <h3 className="text-xl md:text-2xl text-gray-600 mb-6">
              Intelligent Mathematics Evaluation for Years 3–12
            </h3>
          </div>
          
          <div className="space-y-4 mb-8">
            <div className="flex items-center justify-center space-x-2 text-green-600">
              <span className="text-2xl">🤖</span>
              <span className="text-lg">Personalized questions tailored to your level</span>
            </div>
            <div className="flex items-center justify-center space-x-2 text-green-600">
              <span className="text-2xl">📚</span>
              <span className="text-lg">Curriculum-aligned content</span>
            </div>
            <div className="flex items-center justify-center space-x-2 text-green-600">
              <span className="text-2xl">⏱️</span>
              <span className="text-lg">Adaptive timing based on complexity</span>
            </div>
            <div className="flex items-center justify-center space-x-2 text-green-600">
              <span className="text-2xl">📊</span>
              <span className="text-lg">Detailed performance analytics</span>
            </div>
            <div className="flex items-center justify-center space-x-2 text-blue-600">
              <span className="text-2xl">⏭️</span>
              <span className="text-lg">Navigate between questions freely</span>
            </div>
          </div>
          
          <button
            onClick={onStart}
            className="bg-gradient-to-r from-blue-500 to-green-500 hover:from-blue-600 hover:to-green-600 text-white font-bold py-4 px-8 rounded-full text-xl transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            🚀 Generate My Personalized Test
          </button>
        </div>
      </div>
    </div>
  );
};

// Task 5: Enhanced Question Navigation Component (Collapsible Left Panel)
const QuestionNavigationPanel = ({ 
  questions, 
  currentQuestionIndex, 
  answers, 
  skippedQuestions, 
  markedForReview, 
  onQuestionSelect 
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true); // Default to collapsed

  const getQuestionStatus = (index) => {
    if (answers[index]) return 'answered';
    if (markedForReview.has(index)) return 'review';
    if (skippedQuestions.has(index)) return 'skipped';
    return 'unanswered';
  };

  const getStatusColor = (status, isActive) => {
    if (isActive) return 'bg-purple-600 text-white border-purple-600';
    
    switch (status) {
      case 'answered':
        return 'bg-blue-500 text-white border-blue-500';
      case 'review':
        return 'bg-orange-500 text-white border-orange-500';
      case 'skipped':
        return 'bg-gray-400 text-white border-gray-400';
      default:
        return 'bg-white text-gray-700 border-gray-300 hover:border-gray-400';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'answered':
        return '✓';
      case 'review':
        return '⚠';
      case 'skipped':
        return '−';
      default:
        return '';
    }
  };

  const togglePanel = () => {
    setIsCollapsed(!isCollapsed);
  };

  // Mobile-friendly overlay when expanded
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setIsCollapsed(true);
    }
  };

  return (
    <>
      {/* Overlay for mobile when expanded */}
      {!isCollapsed && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={handleOverlayClick}
        ></div>
      )}
      
      {/* Panel */}
      <div className={`fixed left-0 top-0 bottom-0 bg-white border-r-2 border-gray-200 shadow-lg z-40 overflow-y-auto transition-transform duration-300 ease-in-out ${
        isCollapsed ? 'w-12 -translate-x-0' : 'w-64 md:w-80'
      }`}>
        
        {/* Toggle Button */}
        <button
          onClick={togglePanel}
          className="absolute top-4 right-2 w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold hover:bg-blue-600 transition-colors duration-200 shadow-md z-50"
          title={isCollapsed ? 'Expand Panel' : 'Collapse Panel'}
        >
          {isCollapsed ? '▶' : '◀'}
        </button>

        {/* Collapsed State - Mini Icons */}
        {isCollapsed && (
          <div className="p-2 mt-12">
            <div className="space-y-2">
              {questions.map((_, index) => {
                const status = getQuestionStatus(index);
                const isActive = index === currentQuestionIndex;
                const statusColor = getStatusColor(status, isActive);
                const icon = getStatusIcon(status);

                return (
                  <button
                    key={index}
                    onClick={() => onQuestionSelect(index)}
                    className={`relative h-8 w-8 rounded border text-xs font-semibold transition-all duration-200 flex items-center justify-center ${statusColor}`}
                    title={`Question ${index + 1}: ${status}${isActive ? ' (Current)' : ''}`}
                  >
                    <span className="text-xs">
                      {index + 1}
                    </span>
                    {icon && (
                      <span className="absolute -top-1 -right-1 text-xs">
                        {icon}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {/* Expanded State - Full Panel */}
        {!isCollapsed && (
          <div className="p-4 mt-12">
            {/* Header */}
            <div className="mb-4">
              <h3 className="text-lg font-bold text-gray-800 mb-2">Questions</h3>
              <div className="text-sm text-gray-600">
                <div className="flex items-center mb-1">
                  <div className="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
                  Answered
                </div>
                <div className="flex items-center mb-1">
                  <div className="w-3 h-3 bg-orange-500 rounded-full mr-2"></div>
                  Review
                </div>
                <div className="flex items-center mb-1">
                  <div className="w-3 h-3 bg-gray-400 rounded-full mr-2"></div>
                  Skipped
                </div>
                <div className="flex items-center">
                  <div className="w-3 h-3 bg-white border border-gray-400 rounded-full mr-2"></div>
                  Unanswered
                </div>
              </div>
            </div>

            {/* Question Grid */}
            <div className="grid grid-cols-4 gap-2">
              {questions.map((_, index) => {
                const status = getQuestionStatus(index);
                const isActive = index === currentQuestionIndex;
                const statusColor = getStatusColor(status, isActive);
                const icon = getStatusIcon(status);

                return (
                  <button
                    key={index}
                    onClick={() => onQuestionSelect(index)}
                    className={`relative h-12 w-12 rounded-lg border-2 text-xs font-semibold transition-all duration-200 flex items-center justify-center ${statusColor}`}
                    title={`Question ${index + 1}: ${status}${isActive ? ' (Current)' : ''}`}
                  >
                    <span className="text-xs">
                      {index + 1}
                    </span>
                    {icon && (
                      <span className="absolute -top-1 -right-1 text-xs">
                        {icon}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
            
            {/* Progress Summary */}
            <div className="mt-6 p-3 bg-gray-50 rounded-lg">
              <div className="text-sm text-gray-700">
                <div className="flex justify-between mb-1">
                  <span>Answered:</span>
                  <span className="font-semibold">{Object.keys(answers).length}/{questions.length}</span>
                </div>
                <div className="flex justify-between mb-1">
                  <span>Review:</span>
                  <span className="font-semibold">{markedForReview.size}</span>
                </div>
                <div className="flex justify-between">
                  <span>Skipped:</span>
                  <span className="font-semibold">{skippedQuestions.size}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

// Updated AI Test Screen Component (Tasks 4 & 5)
const AITestScreen = ({ studentData, aiQuestions, onComplete }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [skippedQuestions, setSkippedQuestions] = useState(new Set());
  const [markedForReview, setMarkedForReview] = useState(new Set());
  const [testStartTime] = useState(Date.now());
  const [timeLeft, setTimeLeft] = useState(60 * 60); // 60 minutes
  const [showFinishWarning, setShowFinishWarning] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // New state for submission loading

  // Timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          handleFinishTest();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return hours > 0 
      ? `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
      : `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  const handleAnswer = (optionIndex) => {
    const currentQuestion = aiQuestions[currentQuestionIndex];
    const selectedAnswer = currentQuestion.options[optionIndex];
    const isCorrect = optionIndex === currentQuestion.correct_index;

    // Store answer without showing feedback
    setAnswers(prev => ({
      ...prev,
      [currentQuestionIndex]: {
        questionIndex: currentQuestionIndex,
        selectedOption: optionIndex,
        selectedAnswer,
        correct: isCorrect,
        question: currentQuestion
      }
    }));

    // Remove from skipped and review if it was there
    setSkippedQuestions(prev => {
      const updated = new Set(prev);
      updated.delete(currentQuestionIndex);
      return updated;
    });

    setMarkedForReview(prev => {
      const updated = new Set(prev);
      updated.delete(currentQuestionIndex);
      return updated;
    });

    // Log the answer
    testLogger.logStudentAnswer(currentQuestionIndex, currentQuestion, selectedAnswer, isCorrect);
  };

  const handleSkip = () => {
    setSkippedQuestions(prev => new Set([...prev, currentQuestionIndex]));
    
    // Remove from marked for review if it was there
    setMarkedForReview(prev => {
      const updated = new Set(prev);
      updated.delete(currentQuestionIndex);
      return updated;
    });

    // Auto-advance to next question
    goToNextQuestion();
  };

  const handleMarkForReview = () => {
    setMarkedForReview(prev => {
      const updated = new Set(prev);
      if (updated.has(currentQuestionIndex)) {
        updated.delete(currentQuestionIndex);
      } else {
        updated.add(currentQuestionIndex);
      }
      return updated;
    });
  };

  const goToNextQuestion = () => {
    if (currentQuestionIndex < aiQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  const goToPreviousQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleNextWithoutAnswer = () => {
    // If no answer selected, mark as skipped and move to next
    if (!answers[currentQuestionIndex]) {
      setSkippedQuestions(prev => new Set([...prev, currentQuestionIndex]));
    }
    goToNextQuestion();
  };

  const handleFinishTest = () => {
    const unansweredCount = aiQuestions.length - Object.keys(answers).length;
    const reviewCount = markedForReview.size;
    
    if (unansweredCount > 0 || reviewCount > 0) {
      setShowFinishWarning(true);
    } else {
      confirmFinishTest();
    }
  };

  const confirmFinishTest = async () => {
    // Issue 1 Fix: Prevent multiple submissions
    if (isSubmitting) {
      return; // Prevent multiple clicks
    }
    
    setIsSubmitting(true); // Disable button and show loading state
    setShowFinishWarning(false); // Close any warning dialog
    
    try {
      // Mark all remaining unanswered questions as skipped
      const finalSkippedQuestions = new Set(skippedQuestions);
      for (let i = 0; i < aiQuestions.length; i++) {
        if (!answers[i]) {
          finalSkippedQuestions.add(i);
        }
      }

      const testDuration = Date.now() - testStartTime;
      const correctAnswers = Object.values(answers).filter(result => result.correct).length;
      const scorePercentage = ((correctAnswers / aiQuestions.length) * 100).toFixed(2);
      
      testLogger.logTestCompletion(
        aiQuestions.length,
        correctAnswers,
        finalSkippedQuestions.size,
        testDuration
      );

      // Feature 4: Send test report emails
      try {
        const emailResult = await sendTestReportEmails(studentData, {
          totalQuestions: aiQuestions.length,
          correctAnswers,
          scorePercentage: parseFloat(scorePercentage),
          testDuration: Math.floor(testDuration / 1000),
          answers,
        questions: aiQuestions,
        skippedQuestions: finalSkippedQuestions
      });
      
      if (emailResult.success) {
        console.log('Emails sent successfully');
      }
    } catch (emailError) {
      console.error('Failed to send emails:', emailError);
      // Don't block completion for email failures
    }

    // Save test results to database
    let testResultsSaved = false;
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const testResultData = {
        student_name: `${studentData.firstName} ${studentData.lastName}`,
        year_level: studentData.yearLevel,
        total_questions: aiQuestions.length,
        correct_answers: correctAnswers,
        score_percentage: parseFloat(scorePercentage),
        time_taken: Math.floor(testDuration / 1000), // Convert to seconds
        test_data: {
          answers: answers,
          questions: aiQuestions,
          skipped_questions: Array.from(finalSkippedQuestions),
          marked_for_review: Array.from(markedForReview),
          student_info: studentData,
          test_logs: testLogger.getAllLogs()
        }
      };

      const response = await fetch(`${BACKEND_URL}/api/test-results`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(testResultData)
      });

      if (response.ok) {
        console.log('Test results saved successfully');
        testResultsSaved = true;
      } else {
        console.error('Failed to save test results');
      }
    } catch (error) {
      console.error('Error saving test results:', error);
    }

    // Record test completion for email usage tracking
    let testCompletionRecorded = false;
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const completeTestResponse = await fetch(`${BACKEND_URL}/api/complete-test`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: studentData.email,
          student_name: `${studentData.firstName} ${studentData.lastName}`,
          year_level: studentData.yearLevel
        })
      });

      if (completeTestResponse.ok) {
        const result = await completeTestResponse.json();
        console.log('Test completion recorded:', result.message);
        testCompletionRecorded = true;
      } else {
        console.error('Failed to record test completion');
      }
    } catch (error) {
      console.error('Error recording test completion:', error);
    }

    // Only proceed to completion screen if critical operations succeeded or in demo mode
    if (testResultsSaved || !process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL.includes('localhost')) {
      // Debug what we're passing to onComplete
      console.log('Calling onComplete with:', { 
        answers, 
        aiQuestions: aiQuestions?.length, 
        finalSkippedQuestions: finalSkippedQuestions?.size 
      });
      
      // Proceed to completion screen
      onComplete(answers, aiQuestions, finalSkippedQuestions);
    } else {
      // Show error message if database operations failed
      alert('There was an error saving your test results. Please check your internet connection and try again.');
      
      // For now, still proceed to completion screen in demo mode (remove this in production)
      console.log('Proceeding in demo mode - test results not saved to database');
      console.log('Demo mode - calling onComplete with:', { 
        answers, 
        aiQuestions: aiQuestions?.length, 
        finalSkippedQuestions: finalSkippedQuestions?.size 
      });
      onComplete(answers, aiQuestions, finalSkippedQuestions);
    }
  } catch (error) {
    console.error('Error during test submission:', error);
    alert('There was an error submitting your test. Please try again.');
  } finally {
    setIsSubmitting(false); // Re-enable button regardless of success/failure
  }
};

  const currentQuestion = aiQuestions[currentQuestionIndex];
  const answeredCount = Object.keys(answers).length;
  const progress = (answeredCount / aiQuestions.length) * 100;

  // Finish Warning Modal
  if (showFinishWarning) {
    const unansweredCount = aiQuestions.length - Object.keys(answers).length;
    const reviewCount = markedForReview.size;
    
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-3xl shadow-xl max-w-md w-full p-8">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-orange-600 mb-4">⚠️ Ready to Submit?</h2>
            
            {unansweredCount > 0 && (
              <p className="text-lg text-gray-700 mb-4">
                You have <strong>{unansweredCount}</strong> unanswered question{unansweredCount > 1 ? 's' : ''}.
              </p>
            )}
            
            {reviewCount > 0 && (
              <p className="text-lg text-gray-700 mb-4">
                You have <strong>{reviewCount}</strong> question{reviewCount > 1 ? 's' : ''} marked for review.
              </p>
            )}
            
            <p className="text-gray-600 mb-6">
              Are you sure you want to submit your test?
            </p>
            
            <div className="space-y-3">
              <button
                onClick={confirmFinishTest}
                disabled={isSubmitting}
                className={`w-full font-bold py-3 px-6 rounded-xl text-lg transition-all duration-300 ${
                  isSubmitting 
                    ? 'bg-gray-400 cursor-not-allowed text-white' 
                    : 'bg-green-500 hover:bg-green-600 text-white'
                }`}
              >
                {isSubmitting ? (
                  <>
                    <span className="animate-spin mr-2">⏳</span>
                    Generating your report...
                  </>
                ) : (
                  'Yes, Submit Test'
                )}
              </button>
              <button
                onClick={() => setShowFinishWarning(false)}
                disabled={isSubmitting}
                className={`w-full font-bold py-3 px-6 rounded-xl text-lg transition-all duration-300 ${
                  isSubmitting 
                    ? 'bg-gray-300 cursor-not-allowed text-gray-500' 
                    : 'bg-blue-500 hover:bg-blue-600 text-white'
                }`}
              >
                Continue Test
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50">
      {/* Left Navigation Panel */}
      <QuestionNavigationPanel
        questions={aiQuestions}
        currentQuestionIndex={currentQuestionIndex}
        answers={answers}
        skippedQuestions={skippedQuestions}
        markedForReview={markedForReview}
        onQuestionSelect={setCurrentQuestionIndex}
      />

      {/* Main Content with Dynamic Left Margin - adapts to collapsible panel */}
      <div className="ml-12 p-4 transition-all duration-300">
        <div className="max-w-4xl mx-auto">
          {/* Header - Mobile Responsive */}
          <div className="bg-white rounded-2xl md:rounded-3xl shadow-lg p-4 md:p-6 mb-4 md:mb-6">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
              <h2 className="text-xl md:text-2xl font-bold text-blue-600 mb-2 sm:mb-0">
                🤖 Question {currentQuestionIndex + 1} of {aiQuestions.length}
              </h2>
              <div className="bg-red-100 text-red-600 px-3 md:px-4 py-2 rounded-full font-bold text-sm">
                ⏰ {formatTime(timeLeft)}
              </div>
            </div>
            
            {/* Progress Bar */}
            <div className="w-full bg-gray-200 rounded-full h-2 md:h-3 mb-4">
              <div 
                className="bg-gradient-to-r from-blue-500 to-green-500 h-2 md:h-3 rounded-full transition-all duration-500"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            
            {/* Status Info - Mobile Responsive */}
            <div className="flex flex-col sm:flex-row justify-between text-xs md:text-sm text-gray-600 space-y-1 sm:space-y-0">
              <span>Answered: {answeredCount}/{aiQuestions.length}</span>
              <span>Marked for Review: {markedForReview.size}</span>
              <span>Skipped: {skippedQuestions.size}</span>
            </div>
          </div>

          {/* Question Card - Now using EnhancedQuestionDisplay for diagram support */}
          <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl p-4 md:p-8 mb-4 md:mb-6">
            <EnhancedQuestionDisplay
              key={`question-${currentQuestion?.id}-${currentQuestionIndex}`}
              question={currentQuestion}
              questionNumber={currentQuestionIndex + 1}
              selectedAnswer={answers[currentQuestionIndex]?.selectedOption}
              onAnswerSelect={handleAnswer}
              showCorrectAnswer={false}
              className="mb-6 md:mb-8"
            />

            {/* Question Controls - Mobile Responsive */}
            <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-4 md:mb-6">
              <button
                onClick={handleSkip}
                className="px-4 md:px-6 py-2 md:py-3 bg-yellow-500 hover:bg-yellow-600 text-white rounded-xl font-semibold text-sm md:text-base lg:text-lg transition-all duration-300 transform hover:scale-105 active:scale-95"
              >
                ⏭️ Skip Question
              </button>
              
              <button
                onClick={handleMarkForReview}
                className={`px-3 md:px-6 py-2 md:py-3 rounded-xl font-semibold text-sm md:text-base lg:text-lg transition-all duration-300 transform hover:scale-105 active:scale-95 ${
                  markedForReview.has(currentQuestionIndex)
                    ? 'bg-orange-600 hover:bg-orange-700 text-white'
                    : 'bg-orange-500 hover:bg-orange-600 text-white'
                }`}
              >
                {markedForReview.has(currentQuestionIndex) ? '⚠️ Marked for Review' : '⚠️ Mark for Review'}
              </button>
              
              <button
                onClick={handleFinishTest}
                disabled={isSubmitting}
                className={`px-4 md:px-6 py-2 md:py-3 rounded-xl font-semibold text-sm md:text-base lg:text-lg transition-all duration-300 transform ${
                  isSubmitting 
                    ? 'bg-gray-400 cursor-not-allowed' 
                    : 'bg-green-500 hover:bg-green-600 hover:scale-105 active:scale-95'
                } text-white`}
              >
                {isSubmitting ? (
                  <>
                    <span className="animate-spin mr-2">⏳</span>
                    Generating your report...
                  </>
                ) : (
                  '🏁 Submit Test'
                )}
              </button>
            </div>

            {/* Navigation Controls - Mobile Responsive */}
            <div className="flex justify-between">
              <button
                onClick={goToPreviousQuestion}
                disabled={currentQuestionIndex === 0}
                className="px-4 md:px-6 py-2 md:py-3 bg-gray-500 hover:bg-gray-600 text-white rounded-xl font-semibold text-sm md:text-base transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed active:scale-95"
              >
                ← Previous
              </button>
              
              <button
                onClick={handleNextWithoutAnswer}
                disabled={currentQuestionIndex === aiQuestions.length - 1}
                className="px-4 md:px-6 py-2 md:py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-semibold text-sm md:text-base transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed active:scale-95"
              >
                Next →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Feature 1: Post-Test Feedback Form Component (Replaces Waitlist CTA)
const PostTestFeedbackForm = ({ studentData, onSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    // Section 1: Experience
    q1_ease_of_use: '',
    q2_difficulty_appropriate: '',
    q3_test_length: '',
    
    // Section 2: Evaluation Report
    q4_report_usefulness: '',
    q5_improvement_clarity: '',
    
    // Section 3: Future Features
    q6_personalized_plan_interest: '',
    q7_subscription_willingness: '',
    
    // Section 4: Open Feedback
    q8_liked_most: '',
    q9_improvements: '',
    q10_other_feedback: '',
    
    // Section 5: Beta Interest
    q11_beta_interest: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    const requiredFields = [
      'q1_ease_of_use', 'q2_difficulty_appropriate', 'q3_test_length',
      'q4_report_usefulness', 'q5_improvement_clarity', 
      'q6_personalized_plan_interest', 'q7_subscription_willingness'
    ];
    
    for (const field of requiredFields) {
      if (!formData[field]) {
        alert('Please answer all required questions before submitting.');
        return;
      }
    }

    setIsSubmitting(true);
    
    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      
      const response = await fetch(`${BACKEND_URL}/api/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          student_email: studentData.email,
          student_name: `${studentData.firstName} ${studentData.lastName}`,
          year_level: studentData.yearLevel
        })
      });

      if (response.ok) {
        setShowSuccess(true);
        if (onSuccess) onSuccess();
      } else {
        throw new Error('Failed to submit feedback');
      }
    } catch (error) {
      console.error('Feedback submission error:', error);
      alert('Failed to submit feedback. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (showSuccess) {
    return (
      <div className="bg-green-50 border-2 border-green-200 rounded-2xl p-8 text-center mb-8">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-2xl">✅</span>
        </div>
        <h3 className="text-2xl font-bold text-green-600 mb-2">Thank you for your feedback!</h3>
        <p className="text-gray-600">We appreciate your input and will use it to improve Maths Campus.</p>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-blue-50 to-green-50 border-2 border-blue-200 rounded-2xl p-8 mb-8">
      <div className="text-center mb-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
          📝 Step 2: Give Us Your Feedback
        </h2>
        <p className="text-lg text-gray-700">
          Help us improve Maths Campus by sharing your experience. This will only take 2-3 minutes.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        {/* Section 1: Experience */}
        <div className="bg-white p-6 rounded-xl">
          <h3 className="text-xl font-bold text-gray-800 mb-4">📊 Your Experience</h3>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Q1. How easy was it to understand and complete the test? *
              </label>
              <div className="space-y-2">
                {['Very Easy', 'Easy', 'Neutral', 'Difficult', 'Very Difficult'].map(option => (
                  <label key={option} className="flex items-center">
                    <input
                      type="radio"
                      name="q1_ease_of_use"
                      value={option}
                      checked={formData.q1_ease_of_use === option}
                      onChange={(e) => setFormData({...formData, q1_ease_of_use: e.target.value})}
                      className="mr-3"
                      required
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Q2. Was the difficulty of the questions appropriate for your (or your child's) year level? *
              </label>
              <div className="space-y-2">
                {['Too Easy', 'Just Right', 'Too Hard'].map(option => (
                  <label key={option} className="flex items-center">
                    <input
                      type="radio"
                      name="q2_difficulty_appropriate"
                      value={option}
                      checked={formData.q2_difficulty_appropriate === option}
                      onChange={(e) => setFormData({...formData, q2_difficulty_appropriate: e.target.value})}
                      className="mr-3"
                      required
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Q3. Was the test too long, too short, or about the right length? *
              </label>
              <div className="space-y-2">
                {['Too Short', 'About Right', 'Too Long'].map(option => (
                  <label key={option} className="flex items-center">
                    <input
                      type="radio"
                      name="q3_test_length"
                      value={option}
                      checked={formData.q3_test_length === option}
                      onChange={(e) => setFormData({...formData, q3_test_length: e.target.value})}
                      className="mr-3"
                      required
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Section 2: Evaluation Report */}
        <div className="bg-white p-6 rounded-xl">
          <h3 className="text-xl font-bold text-gray-800 mb-4">📋 Evaluation Report</h3>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Q4. How useful was the performance report you received? *
              </label>
              <div className="space-y-2">
                {['Very Useful', 'Somewhat Useful', 'Not Useful'].map(option => (
                  <label key={option} className="flex items-center">
                    <input
                      type="radio"
                      name="q4_report_usefulness"
                      value={option}
                      checked={formData.q4_report_usefulness === option}
                      onChange={(e) => setFormData({...formData, q4_report_usefulness: e.target.value})}
                      className="mr-3"
                      required
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Q5. Did the report help you understand which areas need improvement? *
              </label>
              <div className="space-y-2">
                {['Yes', 'Somewhat', 'No'].map(option => (
                  <label key={option} className="flex items-center">
                    <input
                      type="radio"
                      name="q5_improvement_clarity"
                      value={option}
                      checked={formData.q5_improvement_clarity === option}
                      onChange={(e) => setFormData({...formData, q5_improvement_clarity: e.target.value})}
                      className="mr-3"
                      required
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Section 3: Future Features */}
        <div className="bg-white p-6 rounded-xl">
          <h3 className="text-xl font-bold text-gray-800 mb-4">🚀 Future Features</h3>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Q6. Would you be interested in a personalized learning plan based on your results? *
              </label>
              <div className="space-y-2">
                {['Yes', 'Maybe', 'No'].map(option => (
                  <label key={option} className="flex items-center">
                    <input
                      type="radio"
                      name="q6_personalized_plan_interest"
                      value={option}
                      checked={formData.q6_personalized_plan_interest === option}
                      onChange={(e) => setFormData({...formData, q6_personalized_plan_interest: e.target.value})}
                      className="mr-3"
                      required
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Q7. If this personalized learning plan was offered for $10/month, would you consider subscribing? *
              </label>
              <div className="space-y-2">
                {['Definitely', 'Maybe', 'Unlikely', 'No'].map(option => (
                  <label key={option} className="flex items-center">
                    <input
                      type="radio"
                      name="q7_subscription_willingness"
                      value={option}
                      checked={formData.q7_subscription_willingness === option}
                      onChange={(e) => setFormData({...formData, q7_subscription_willingness: e.target.value})}
                      className="mr-3"
                      required
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Section 4: Open Feedback */}
        <div className="bg-white p-6 rounded-xl">
          <h3 className="text-xl font-bold text-gray-800 mb-4">💭 Open Feedback</h3>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Q8. What did you like most about your experience?
              </label>
              <textarea
                value={formData.q8_liked_most}
                onChange={(e) => setFormData({...formData, q8_liked_most: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                rows="3"
                placeholder="Tell us what worked well for you..."
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Q9. What could we improve or add to make this better?
              </label>
              <textarea
                value={formData.q9_improvements}
                onChange={(e) => setFormData({...formData, q9_improvements: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                rows="3"
                placeholder="Share your suggestions for improvement..."
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Q10. Any other feedback you'd like to share?
              </label>
              <textarea
                value={formData.q10_other_feedback}
                onChange={(e) => setFormData({...formData, q10_other_feedback: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                rows="3"
                placeholder="Any additional thoughts or comments..."
              />
            </div>
          </div>
        </div>

        {/* Section 5: Beta Interest */}
        <div className="bg-white p-6 rounded-xl">
          <h3 className="text-xl font-bold text-gray-800 mb-4">🧪 Beta Testing</h3>
          
          <div className="flex items-center">
            <input
              type="checkbox"
              id="q11_beta_interest"
              checked={formData.q11_beta_interest}
              onChange={(e) => setFormData({...formData, q11_beta_interest: e.target.checked})}
              className="mr-3 w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
            />
            <label htmlFor="q11_beta_interest" className="text-gray-700">
              Q11. Would you like to be part of our private beta for the personalized learning feature? Yes, contact me via email
            </label>
          </div>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-4 px-8 rounded-xl text-lg font-semibold hover:from-blue-700 hover:to-green-700 transition-all transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
        >
          {isSubmitting ? 'Submitting Feedback...' : 'Submit Feedback'}
        </button>
      </form>
    </div>
  );
};

// Enhanced Completion Screen with 2-Step Process (Change 2)
const AITestCompletionScreen = ({ studentData, results, onRetake, onExit, onShowReport }) => {
  // Debug logging
  console.log('AITestCompletionScreen received data:', { studentData, results });
  
  const [currentStep, setCurrentStep] = useState('feedback'); // 'feedback' or 'results'
  const [feedbackCompleted, setFeedbackCompleted] = useState(false);
  
  const answers = results?.answers || {};
  const skippedQuestions = results?.skippedQuestions || new Set();
  const aiQuestions = results?.questions || [];
  
  // Additional debug logging
  console.log('Processed data:', { answers, aiQuestions: aiQuestions.length, studentData });
  
  // Validate data before processing
  if (!answers || typeof answers !== 'object') {
    console.error('Invalid answers data:', answers);
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-3xl shadow-xl max-w-md w-full p-8 text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">⚠️ Error Loading Results</h2>
          <p className="text-gray-600 mb-6">
            There was an issue loading your test results. Please try again.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-xl"
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }
  
  // Calculate statistics
  const topicStats = {};
  const difficultyStats = { Easy: { attempted: 0, correct: 0 }, Medium: { attempted: 0, correct: 0 }, Hard: { attempted: 0, correct: 0 } };
  
  // Safely process answers
  try {
    Object.values(answers).forEach(result => {
      if (!result || !result.question) {
        console.warn('Invalid result data:', result);
        return;
      }
      
      const topic = result.question.topic;
      const difficulty = result.question.difficulty;
      
      if (!topic || !difficulty) {
        console.warn('Missing topic or difficulty:', result.question);
        return;
      }
      if (!topicStats[topic]) {
        topicStats[topic] = { attempted: 0, correct: 0, questions: [] };
      }
      
      topicStats[topic].attempted++;
      if (result.correct) {
        topicStats[topic].correct++;
      }
      topicStats[topic].questions.push(result.question);
      
      if (difficultyStats[difficulty]) {
        difficultyStats[difficulty].attempted++;
        if (result.correct) {
          difficultyStats[difficulty].correct++;
        }
      }
    });
  } catch (error) {
    console.error('Error processing test results:', error);
  }

  const totalQuestions = aiQuestions.length;
  const answeredQuestions = Object.keys(answers || {}).length;
  const correctAnswers = Object.values(answers || {}).filter(result => result && result.correct).length;
  const overallAccuracy = totalQuestions > 0 ? Math.round((correctAnswers / totalQuestions) * 100) : 0;
  const attemptedAccuracy = answeredQuestions > 0 ? Math.round((correctAnswers / answeredQuestions) * 100) : 0;

  // Issue 3 Fix: Check remaining free attempts (simplified)
  const [remainingTests, setRemainingTests] = useState(3); // Default to 3 for now
  const [checkingTests, setCheckingTests] = useState(false);

  const handleFeedbackComplete = () => {
    setFeedbackCompleted(true);
    setCurrentStep('results');
  };

  const handleSkipFeedback = () => {
    setCurrentStep('results');
  };

  // Step 1: Feedback Form
  if (currentStep === 'feedback') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50 flex items-center justify-center p-4">
        <div className="max-w-4xl w-full">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <div className="text-center mb-8">
              <h1 className="text-4xl md:text-5xl font-bold text-green-600 mb-4">
                🎉 Test Complete!
              </h1>
              <h2 className="text-2xl md:text-3xl text-gray-700 mb-6">
                Thank you for completing your mathematics evaluation!
              </h2>
              
              <div className="bg-gradient-to-r from-blue-100 to-green-100 rounded-2xl p-6 mb-6">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-blue-600">{correctAnswers}/{totalQuestions}</div>
                    <div className="text-sm text-gray-600">Overall Score</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-green-600">{overallAccuracy}%</div>
                    <div className="text-sm text-gray-600">Overall Accuracy</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-purple-600">{attemptedAccuracy}%</div>
                    <div className="text-sm text-gray-600">Attempted Accuracy</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-orange-600">{skippedQuestions.size}</div>
                    <div className="text-sm text-gray-600">Questions Skipped</div>
                  </div>
                </div>
              </div>
            </div>

            <PostTestFeedbackForm 
              studentData={studentData} 
              onSuccess={handleFeedbackComplete}
            />

            <div className="text-center mt-6">
              <button
                onClick={handleSkipFeedback}
                className="text-gray-500 hover:text-gray-700 underline"
              >
                Skip Feedback and View Results
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Step 2: Results Display
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50 flex items-center justify-center p-4">
      <div className="max-w-5xl w-full">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <div className="text-center mb-8">
            {feedbackCompleted && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-6">
                <p className="text-green-700">✅ Thank you for your feedback! Here are your detailed results:</p>
              </div>
            )}
            
            <h1 className="text-4xl md:text-5xl font-bold text-green-600 mb-4">
              📊 Your Mathematics Assessment Results
            </h1>
            <h2 className="text-2xl md:text-3xl text-gray-700 mb-6">
              Comprehensive Performance Analysis
            </h2>
            
            <div className="bg-gradient-to-r from-blue-100 to-green-100 rounded-2xl p-6 mb-6">
              <p className="text-lg text-gray-700 mb-4">
                Hi {studentData.firstName}! You've completed your {studentData.yearLevel} mathematics assessment.
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600">{correctAnswers}/{totalQuestions}</div>
                  <div className="text-sm text-gray-600">Overall Score</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-green-600">{overallAccuracy}%</div>
                  <div className="text-sm text-gray-600">Overall Accuracy</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-purple-600">{attemptedAccuracy}%</div>
                  <div className="text-sm text-gray-600">Attempted Accuracy</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-orange-600">{skippedQuestions.size}</div>
                  <div className="text-sm text-gray-600">Questions Skipped</div>
                </div>
              </div>
            </div>
            
            {/* Performance Analytics */}
            <div className="bg-white border-2 border-gray-200 rounded-2xl p-6 mb-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">📈 Performance Analytics</h3>
              
              {/* Difficulty Analysis */}
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-700 mb-4">Performance by Difficulty Level</h4>
                <div className="grid grid-cols-3 gap-4">
                  {Object.entries(difficultyStats).map(([difficulty, stats]) => (
                    stats.attempted > 0 && (
                      <div key={difficulty} className="text-center p-4 bg-gray-50 rounded-lg">
                        <div className={`text-2xl font-bold ${
                          difficulty === 'Easy' ? 'text-green-600' :
                          difficulty === 'Medium' ? 'text-yellow-600' : 'text-red-600'
                        }`}>
                          {Math.round((stats.correct / stats.attempted) * 100)}%
                        </div>
                        <div className="text-sm text-gray-600">{difficulty}</div>
                        <div className="text-xs text-gray-500">{stats.correct}/{stats.attempted}</div>
                      </div>
                    )
                  ))}
                </div>
              </div>
              
              {/* Topic Performance */}
              {Object.keys(topicStats).length > 0 && (
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse bg-white rounded-lg overflow-hidden shadow-sm">
                    <thead>
                      <tr className="bg-gradient-to-r from-blue-500 to-green-500 text-white">
                        <th className="p-3 text-left font-semibold">Topic</th>
                        <th className="p-3 text-center font-semibold">Attempted</th>
                        <th className="p-3 text-center font-semibold">Correct</th>
                        <th className="p-3 text-center font-semibold">Accuracy</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(topicStats).map(([topic, stats], index) => (
                        <tr key={topic} className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-blue-50 transition-colors`}>
                          <td className="p-3 font-semibold text-gray-800">
                            📚 {topic}
                          </td>
                          <td className="p-3 text-center text-gray-700">{stats.attempted}</td>
                          <td className="p-3 text-center">
                            <span className="text-green-600 font-bold">{stats.correct}</span>
                            <span className="text-gray-500 ml-1">/ {stats.attempted}</span>
                          </td>
                          <td className="p-3 text-center">
                            <div className={`inline-block px-3 py-1 rounded-full text-sm font-bold ${
                              Math.round((stats.correct / stats.attempted) * 100) >= 80 
                                ? 'bg-green-100 text-green-600'
                                : Math.round((stats.correct / stats.attempted) * 100) >= 60
                                ? 'bg-yellow-100 text-yellow-600'
                                : 'bg-red-100 text-red-600'
                            }`}>
                              {Math.round((stats.correct / stats.attempted) * 100)}%
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            
            {/* Performance Insights - Fixed */}
            <div className="bg-purple-50 rounded-2xl p-6 mb-8">
              <h4 className="text-xl font-bold text-purple-800 mb-4">🎯 Performance Insights</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div>
                  <span className="font-semibold text-green-600">Identified Strengths:</span>
                  <div className="ml-2">
                    {Object.entries(topicStats)
                      .filter(([_, stats]) => (stats.correct / stats.attempted) >= 0.8)
                      .map(([topic]) => topic)
                      .join(', ') || 'Continue practicing to identify strengths!'}
                  </div>
                </div>
                <div>
                  <span className="font-semibold text-orange-600">Recommended Focus:</span>
                  <div className="ml-2">
                    {(() => {
                      // Get topics with poor performance (< 60%)
                      const weakTopics = Object.entries(topicStats)
                        .filter(([_, stats]) => (stats.correct / stats.attempted) < 0.6)
                        .map(([topic]) => topic);
                      
                      // Get all topics that were available in the test
                      const allAvailableTopics = [...new Set(aiQuestions.map(q => q.topic))];
                      
                      // Get topics that were attempted
                      const attemptedTopics = Object.keys(topicStats);
                      
                      // Find unattempted topics
                      const unattemptedTopics = allAvailableTopics.filter(topic => !attemptedTopics.includes(topic));
                      
                      // Combine weak performance topics with unattempted topics
                      const recommendedFocus = [...weakTopics, ...unattemptedTopics];
                      
                      return recommendedFocus.length > 0 
                        ? recommendedFocus.join(', ')
                        : 'Great job! Continue practicing to maintain your performance.';
                    })()}
                  </div>
                </div>
              </div>
            </div>
            
            <p className="text-lg text-gray-600 mb-8">
              📧 Your detailed analysis report will be sent to <strong>{studentData.email}</strong>!
            </p>
          </div>
          
          <div className="space-y-4">
            <button
              onClick={onShowReport}
              className="w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-bold py-4 px-6 rounded-xl text-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              📊 View Detailed Report
            </button>
            
            <div className="flex flex-col md:flex-row gap-4">
              {/* Simplified Generate New Test button */}
              <button
                onClick={onRetake}
                className="flex-1 bg-gradient-to-r from-blue-500 to-green-500 hover:from-blue-600 hover:to-green-600 text-white font-bold py-4 px-6 rounded-xl text-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
              >
                🔄 Generate New Test
              </button>
              
              <button
                onClick={onExit}
                className="flex-1 bg-gray-500 hover:bg-gray-600 text-white font-bold py-4 px-6 rounded-xl text-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
              >
                ✅ Exit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Enhanced Report Preview Modal with AI Analytics
const AIReportPreviewModal = ({ studentData, results, onClose }) => {
  const answers = results.answers || {};
  const skippedQuestions = results.skippedQuestions || new Set();
  const aiQuestions = results.questions || [];
  const testLogs = testLogger.getAllLogs();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-3xl shadow-xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-8">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-3xl font-bold text-blue-600">📋 AI-Powered Assessment Report</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            >
              ✕
            </button>
          </div>
          
          {/* Student & Test Info */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <h3 className="text-xl font-semibold mb-4">Student Information</h3>
              <div className="bg-gray-50 rounded-xl p-4">
                <p><strong>Name:</strong> {studentData.firstName} {studentData.lastName}</p>
                <p><strong>Year Level:</strong> {studentData.yearLevel}</p>
                <p><strong>Test Date:</strong> {new Date().toLocaleDateString()}</p>
                <p><strong>Test Type:</strong> 🤖 AI-Generated Assessment</p>
              </div>
            </div>
            
            <div>
              <h3 className="text-xl font-semibold mb-4">AI Test Generation</h3>
              <div className="bg-blue-50 rounded-xl p-4">
                <p><strong>Questions Generated:</strong> {aiQuestions.length}</p>
                <p><strong>AI Model:</strong> Google Gemini 2.5 Pro</p>
                <p><strong>Generation Time:</strong> ~60-90 seconds</p>
                <p><strong>Curriculum:</strong> Australian National Standards</p>
              </div>
            </div>
          </div>

          {/* Detailed Question Review */}
          <div className="mb-6">
            <h3 className="text-xl font-semibold mb-4">📝 Question-by-Question Review</h3>
            <div className="space-y-4 max-h-96 overflow-y-auto">
              {aiQuestions.map((question, index) => {
                const studentAnswer = answers[index];
                const wasSkipped = skippedQuestions.has(index);
                
                return (
                  <div key={index} className="border rounded-lg p-4 bg-gray-50">
                    <div className="flex justify-between items-start mb-3">
                      <h4 className="font-semibold text-gray-800">
                        Question {index + 1}: {question.topic} ({question.difficulty})
                      </h4>
                      <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                        wasSkipped 
                          ? 'bg-gray-200 text-gray-700'
                          : studentAnswer?.correct 
                            ? 'bg-green-200 text-green-700'
                            : 'bg-red-200 text-red-700'
                      }`}>
                        {wasSkipped ? 'Skipped' : studentAnswer?.correct ? 'Correct' : 'Incorrect'}
                      </span>
                    </div>
                    
                    <p className="text-gray-700 mb-3">{question.question_text}</p>
                    
                    <div className="grid grid-cols-2 gap-2 mb-3">
                      {question.options.map((option, optIndex) => (
                        <div key={optIndex} className={`p-2 rounded text-sm ${
                          optIndex === question.correct_index 
                            ? 'bg-green-100 text-green-800 font-semibold'
                            : studentAnswer?.selectedOption === optIndex 
                              ? 'bg-red-100 text-red-800'
                              : 'bg-white text-gray-600'
                        }`}>
                          {String.fromCharCode(65 + optIndex)}) {option}
                          {optIndex === question.correct_index && ' ✓'}
                          {studentAnswer?.selectedOption === optIndex && optIndex !== question.correct_index && ' ✗'}
                        </div>
                      ))}
                    </div>
                    
                    {question.explanation && (
                      <div className="bg-blue-50 p-3 rounded text-sm">
                        <strong>Explanation:</strong> {question.explanation}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* AI Generation Logs - Filtered */}
          <div className="mb-6">
            <h3 className="text-xl font-semibold mb-4">🔧 Generation Process</h3>
            <div className="bg-gray-50 rounded-xl p-4 max-h-48 overflow-y-auto">
              {testLogs
                .filter(log => log.type !== 'AI_PROMPT') // Remove AI prompts
                .map((log, index) => (
                <div key={index} className="text-sm mb-2">
                  <span className="text-gray-500">{new Date(log.timestamp).toLocaleTimeString()}</span>
                  <span className="ml-2 font-semibold text-blue-600">[{log.type}]</span>
                  <span className="ml-2">
                    {log.type === 'AI_RESPONSE' 
                      ? `Generated ${log.data.questionsGenerated} questions successfully`
                      : JSON.stringify(log.data, null, 1).substring(0, 100)}...
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={onClose}
              className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-xl text-lg transition-all duration-300"
            >
              Close Report
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main App Component with Landing Page and AI Integration
// Main authenticated app content
function AppContent() {
  const { 
    isAuthenticated, 
    user, 
    userProfile, 
    testEligibility, 
    refreshTestEligibility,
    showGradeModal,
    closeGradeModal,
    hasRequiredProfile
  } = useAuth();
  const [currentScreen, setCurrentScreen] = useState('landing');
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authModalMode, setAuthModalMode] = useState('login');
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [studentData, setStudentData] = useState(null);
  const [aiQuestions, setAiQuestions] = useState([]);
  const [testResults, setTestResults] = useState(null);
  const [showReportModal, setShowReportModal] = useState(false);
  
  // Practice Session States
  const [practiceSessionData, setPracticeSessionData] = useState(null);
  const [activePracticeSession, setActivePracticeSession] = useState(null);

  // Test Logger
  const testLogger = useRef(new TestLogger()).current;

  // Auto-redirect authenticated users to dashboard
  useEffect(() => {
    if (isAuthenticated && currentScreen === 'landing') {
      setCurrentScreen('dashboard');
    }
  }, [isAuthenticated, currentScreen]);

  // Track page views with LogRocket
  useEffect(() => {
    if (currentScreen) {
      logRocketEvents.pageView(currentScreen);
    }
  }, [currentScreen]);

  // Authentication handlers
  const handleShowAuth = (mode = 'login') => {
    setAuthModalMode(mode);
    setShowAuthModal(true);
  };

  // Dashboard handlers
  const handleDashboardStartTest = async () => {
    console.log('🔍 handleDashboardStartTest called');
    console.log('🔍 hasRequiredProfile:', hasRequiredProfile);
    console.log('🔍 userProfile:', userProfile);
    console.log('🔍 testEligibility:', testEligibility);
    console.log('🔍 user:', user);
    
    if (!testEligibility?.can_take_test) {
      console.log('🔍 Cannot take test:', testEligibility?.message);
      alert(testEligibility?.message || 'Test limit reached. Please upgrade to continue.');
      return;
    }
    
    // Check if user has required profile (grade for non-admin users)
    // If userProfile is null but user exists, we'll use user metadata as fallback
    const effectiveRole = userProfile?.role || 'student';
    const effectiveGrade = userProfile?.grade || user?.user_metadata?.grade;
    
    if (!effectiveGrade && effectiveRole !== 'admin') {
      console.log('🔍 Missing grade information, showing grade modal');
      // Show grade modal for incomplete profiles (non-admin users only)
      setShowAuthModal(false); // Ensure auth modal is closed
      // Grade modal should already be visible from AuthContext
      return;
    }

    // Generate test directly using user profile data with fallbacks
    const effectiveName = userProfile?.full_name || user?.user_metadata?.full_name || user?.email?.split('@')[0] || 'Student';
    const studentData = {
      firstName: effectiveName.split(' ')[0] || 'Student',
      lastName: effectiveName.split(' ').slice(1).join(' ') || 'User',
      yearLevel: effectiveGrade || 'Year 6', // Use the effective grade we calculated above
      email: user?.email,
      user_id: user?.id
    };

    console.log('🔍 Student data:', studentData);
    setStudentData(studentData);
    setIsGeneratingQuestions(true);
    console.log('🔍 Starting question generation...');
    
    try {
      if (!aiGenerator) {
        console.error('🔍 AI Generator not initialized');
        throw new Error('AI Generator not initialized - API key missing');
      }

      // Get curriculum map for the user's grade
      const curriculumMap = CURRICULUM_MAPS[studentData.yearLevel] || CURRICULUM_MAPS['Year 6'];
      console.log('🔍 Using curriculum map for:', studentData.yearLevel);
      
      // Generate AI questions based on curriculum
      console.log('🔍 Calling aiGenerator.generateQuestions...');
      const generatedQuestions = await aiGenerator.generateQuestions(studentData.yearLevel, curriculumMap);
      
      if (!generatedQuestions || generatedQuestions.length === 0) {
        throw new Error('No questions generated');
      }

      console.log(`Generated ${generatedQuestions.length} questions for ${studentData.yearLevel}`);
      setAiQuestions(generatedQuestions);
      setCurrentScreen('test');
      setIsGeneratingQuestions(false); // Turn off loading modal after successful generation
      
    } catch (error) {
      console.error('Failed to generate questions:', error);
      alert('Failed to generate your personalized test: ' + error.message + '. Please try again.');
      setIsGeneratingQuestions(false);
    }
  };

  const handleStartSelectiveTest = () => {
    if (!isAuthenticated) {
      setShowAuthModal(true);
      setAuthModalMode('login');
      return;
    }
    if (!hasRequiredProfile) {
      // User is authenticated but missing grade - grade modal will show
      return;
    }
    setCurrentScreen('selective');
    window.history.pushState({}, '', '/selective');
  };

  // Selective progress matrix supports years 4-6; clamp other grades
  const getSelectiveYearLevel = () => {
    const gradeDigits = String(userProfile?.grade || '').match(/\d+/);
    const grade = gradeDigits ? parseInt(gradeDigits[0], 10) : 6;
    return Math.min(6, Math.max(4, grade));
  };

  // Handle URL routing
  useEffect(() => {
    const handleRouting = () => {
      const path = window.location.pathname;
      
      if (path === '/subscription/success') {
        setCurrentScreen('subscription-success');
      } else if (path === '/subscription/cancel') {
        setCurrentScreen('subscription-cancel');
      } else if (path === '/admin' && isAuthenticated && userProfile?.role === 'admin') {
        setCurrentScreen('admin');
      } else if (path === '/admin/questions' && isAuthenticated && userProfile?.role === 'admin') {
        setCurrentScreen('questions');
      } else if (path === '/selective' && isAuthenticated) {
        setCurrentScreen('selective');
      } else if (path === '/dashboard' && isAuthenticated) {
        setCurrentScreen('dashboard');
      } else if (isAuthenticated) {
        // Default to dashboard for authenticated users
        setCurrentScreen('dashboard');
      } else {
        // Default to landing for non-authenticated users
        setCurrentScreen('landing');
      }
    };

    // Handle initial routing
    handleRouting();

    // Listen for browser back/forward navigation
    const handlePopState = () => {
      handleRouting();
    };

    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isAuthenticated, userProfile?.role]);

  // Additional effect to handle URL changes on page load and URL parameters
  useEffect(() => {
    const path = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.slice(1)); // Remove # from hash
    
    // Handle password reset redirect from Supabase (works from any page)
    if (hashParams.get('type') === 'recovery') {
      console.log('🔐 Password reset redirect detected');
      
      // Check if we have the necessary tokens from Supabase
      const accessToken = hashParams.get('access_token');
      const refreshToken = hashParams.get('refresh_token');
      const type = hashParams.get('type');
      
      if (type === 'recovery' && accessToken) {
        console.log('✅ Valid password reset tokens found');
        setShowResetPasswordModal(true);
        // Set to landing page to ensure we're on the main app
        setCurrentScreen('landing');
      } else {
        console.log('❌ Invalid or missing password reset tokens');
        // Redirect to landing page or show error
        setCurrentScreen('landing');
      }
    }
    // Handle password reset from /reset-password path (if routing works)
    else if (path === '/reset-password') {
      console.log('🔐 Password reset path detected, redirecting to home');
      // Redirect to home page - the hash params should be preserved
      window.history.replaceState({}, '', '/' + window.location.hash);
      setCurrentScreen('landing');
    }
    // Handle Stripe redirects - check both path and query parameters
    else if (path === '/subscription/success' || searchParams.get('session_id')) {
      console.log('🎉 Stripe success redirect detected');
      setCurrentScreen('subscription-success');
    } else if (path === '/subscription/cancel' || searchParams.get('cancelled')) {
      console.log('❌ Stripe cancel redirect detected');
      setCurrentScreen('subscription-cancel');
    } else if (searchParams.get('stripe_success')) {
      console.log('🎉 Stripe success redirect detected (legacy)');
      setCurrentScreen('subscription-success');
    } else if (searchParams.get('stripe_cancel')) {
      console.log('❌ Stripe cancel redirect detected (legacy)');
      setCurrentScreen('subscription-cancel');
    } else if (path === '/dashboard') {
      console.log('📊 Dashboard redirect detected');
      // Let the main routing logic handle authentication check
    }
    
    // Debug logging
    console.log('🔍 URL Detection:', {
      pathname: path,
      search: window.location.search,
      sessionId: searchParams.get('session_id'),
      currentScreen: currentScreen
    });
  }, []); // Run once on component mount

  // Navigation handlers
  const navigateToAdmin = () => {
    if (userProfile?.role === 'admin') {
      setCurrentScreen('admin');
      window.history.pushState({}, '', '/admin');
    }
  };

  const navigateToQuestions = () => {
    if (userProfile?.role === 'admin') {
      setCurrentScreen('questions');
      window.history.pushState({}, '', '/admin/questions');
    }
  };

  const navigateToLearningPaths = () => {
    console.log('🟢 NAVIGATING TO LEARNING PATHS - BYPASSING DASHBOARD');
    setCurrentScreen('learning-paths');
    window.history.pushState({}, '', '/learning-paths');
  };

  const navigateToDiagrams = () => {
    if (userProfile?.role === 'admin') {
      setCurrentScreen('diagrams');
      window.history.pushState({}, '', '/admin/diagrams');
    }
  };

  // Handle start evaluation from landing page
  const handleStartEvaluation = () => {
    if (isAuthenticated) {
      if (!hasRequiredProfile) {
        // User is authenticated but missing grade - grade modal will show
        return;
      }
      setCurrentScreen('dashboard');
    } else {
      setShowAuthModal(true);
      setAuthModalMode('login');
    }
  };
  const handleBackToLanding = () => {
    setCurrentScreen('landing');
    setStudentData(null);
    setAiQuestions([]);
    setTestResults(null);
    setShowReportModal(false);
  };

  const handleBackToDashboard = () => {
    if (isAuthenticated) {
      setCurrentScreen('dashboard');
    } else {
      setCurrentScreen('landing');
    }
    setStudentData(null);
    setAiQuestions([]);
    setTestResults(null);
    setShowReportModal(false);
  };

  // Practice Session Handlers
  const handleStartPracticeSession = () => {
    if (!isAuthenticated) {
      setShowAuthModal(true);
      setAuthModalMode('login');
      return;
    }
    
    if (!hasRequiredProfile) {
      // User is authenticated but missing grade - grade modal should show
      // For now, during debugging, let's allow access anyway
      console.log('⚠️ Profile incomplete, but allowing practice access for debugging');
    }
    
    setCurrentScreen('practice-launcher');
  };

  const handlePracticeSessionStart = (sessionData) => {
    setActivePracticeSession(sessionData);
    setCurrentScreen('practice-session');
  };

  const handlePracticeSessionComplete = (score) => {
    console.log(`Practice session completed with score: ${score}%`);
    // Reset practice states
    setActivePracticeSession(null);
    setPracticeSessionData(null);
    // Return to practice launcher to see updated stats
    setCurrentScreen('practice-launcher');
  };

  const handleBackFromPracticeLauncher = () => {
    setCurrentScreen('dashboard');
    setPracticeSessionData(null);
    setActivePracticeSession(null);
  };

  const handleBackFromPracticeSession = () => {
    setCurrentScreen('practice-launcher');
    setActivePracticeSession(null);
  };

  // Test handlers (updated for authentication)
  const handleTestComplete = async (answers, questions, skippedQuestions) => {
    console.log('handleTestComplete called with:', { 
      answers, 
      questions: questions?.length, 
      skippedQuestions: skippedQuestions?.size,
      user: user?.id 
    });
    
    // Validate authenticated user
    if (!user?.id) {
      alert('Authentication error. Please log in again.');
      setCurrentScreen('landing');
      return;
    }
    
    const validatedAnswers = answers && typeof answers === 'object' ? answers : {};
    const validatedQuestions = Array.isArray(questions) ? questions : [];
    const validatedSkipped = skippedQuestions instanceof Set ? skippedQuestions : new Set();
    
    // Include user information in test results
    const testResultsData = {
      answers: validatedAnswers,
      skippedQuestions: validatedSkipped,
      questions: validatedQuestions,
      user_id: user.id,
      user_email: user.email
    };
    
    console.log('Setting test results with user data:', testResultsData);
    
    setTestResults(testResultsData);
    setCurrentScreen('completion');
    
    // Refresh test eligibility after completion
    await refreshTestEligibility();
  };

  const handleRetake = () => {
    if (testEligibility?.can_take_test) {
      handleDashboardStartTest();
    } else {
      alert('You have reached your test limit. Upgrade to take more tests.');
    }
  };

  const handleExit = () => {
    handleBackToDashboard();
  };

  // Existing state declarations from original App component
  const [isGeneratingQuestions, setIsGeneratingQuestions] = useState(false);
  
  // Initialize AI Question Generator
  const [aiGenerator] = useState(() => {
    const apiKey = process.env.REACT_APP_GEMINI_API_KEY;
    if (!apiKey) {
      console.error('Gemini API key not found in environment variables');
      return null;
    }
    return new AIQuestionGenerator(apiKey);
  });

  // Removed duplicate function declarations - already defined above

  // Test completion handler (updated for authentication)
  const handleStudentSubmit = async (data) => {
    // Merge user data with form data for authenticated users
    const enhancedStudentData = {
      ...data,
      email: user?.email || data.email,
      user_id: user?.id
    };
    
    setStudentData(enhancedStudentData);
    setIsGeneratingQuestions(true);
    
    try {
      if (!aiGenerator) {
        throw new Error('AI Generator not initialized - API key missing');
      }

      // Get curriculum map for the student's year level
      const curriculumMap = CURRICULUM_MAPS[data.yearLevel] || CURRICULUM_MAPS['Year 6'];
      
      // Generate AI questions based on curriculum
      const generatedQuestions = await aiGenerator.generateQuestions(data.yearLevel, curriculumMap);
      
      if (!generatedQuestions || generatedQuestions.length === 0) {
        throw new Error('No questions generated');
      }

      console.log(`Generated ${generatedQuestions.length} questions for ${data.yearLevel}`);
      setAiQuestions(generatedQuestions);
      setCurrentScreen('test');
      setIsGeneratingQuestions(false); // Turn off loading modal after successful generation
      
    } catch (error) {
      console.error('Failed to generate questions:', error);
      alert('Failed to generate your personalized test: ' + error.message + '. Please try again.');
      setIsGeneratingQuestions(false);
    }
  };

  return (
    <div className="App">
      {/* Landing Page - shown when not authenticated or explicitly navigated to */}
      {currentScreen === 'landing' && !isAuthenticated && (
        <NewHomePage 
          onStartEvaluation={handleStartEvaluation}
          onStartSelectiveTest={handleStartSelectiveTest}
          isAuthenticated={isAuthenticated}
          onShowAuth={handleShowAuth}
        />
      )}

      {/* Dashboard - authenticated users only */}
      {currentScreen === 'dashboard' && isAuthenticated && (
        <Dashboard
          onStartTest={handleDashboardStartTest}
          onStartSelectiveTest={handleStartSelectiveTest}
          onNavigateToAdmin={navigateToAdmin}
          onNavigateToQuestions={navigateToQuestions}
          onNavigateToLearningPaths={navigateToLearningPaths}
          curriculumMaps={CURRICULUM_MAPS}
          onStartPracticeSession={handleStartPracticeSession}
        />
      )}

      {/* Learning Paths - separate page to avoid Dashboard re-rendering */}
      {currentScreen === 'learning-paths' && isAuthenticated && (
        <LearningPathPage 
          onBackToDashboard={() => {
            console.log('🟢 BACK TO DASHBOARD FROM LEARNING PATHS');
            setCurrentScreen('dashboard');
            window.history.pushState({}, '', '/dashboard');
          }}
        />
      )}

      {/* Selective Exam module - all authenticated students */}
      {currentScreen === 'selective' && isAuthenticated && (
        <div className="min-h-screen bg-gray-50">
          <div className="container mx-auto px-4 py-4">
            <button
              onClick={() => {
                setCurrentScreen('dashboard');
                window.history.pushState({}, '', '/dashboard');
              }}
              className="mc-button mc-button-secondary"
              style={{ marginBottom: '1rem' }}
            >
              ← Back to Dashboard
            </button>
            <SelectiveDashboard
              isAdmin={userProfile?.role === 'admin'}
              yearLevel={getSelectiveYearLevel()}
            />
          </div>
        </div>
      )}

      {/* Admin Dashboard - admin users only */}
      {currentScreen === 'admin' && isAuthenticated && userProfile?.role === 'admin' && (
        <AdminDashboard 
          onNavigateToQuestions={navigateToQuestions}
          onNavigateToDiagrams={navigateToDiagrams}
          onNavigateToDashboard={() => {
            setCurrentScreen('dashboard');
            window.history.pushState({}, '', '/dashboard');
          }}
        />
      )}

      {/* Question Pool Manager - admin users only */}
      {currentScreen === 'questions' && isAuthenticated && userProfile?.role === 'admin' && (
        <QuestionPoolManager 
          onNavigateToAdmin={() => {
            setCurrentScreen('admin');
            window.history.pushState({}, '', '/admin');
          }}
          onNavigateToDashboard={() => {
            setCurrentScreen('dashboard');
            window.history.pushState({}, '', '/dashboard');
          }}
        />
      )}

      {/* Diagram Analysis Tool - admin users only */}
      {currentScreen === 'diagrams' && isAuthenticated && userProfile?.role === 'admin' && (
        <div className="min-h-screen bg-gray-50">
          <div className="container mx-auto px-4 py-8">
            {/* Navigation Header */}
            <div className="mb-6">
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => {
                    setCurrentScreen('admin');
                    window.history.pushState({}, '', '/admin');
                  }}
                  className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                >
                  ← Back to Admin Panel
                </button>
                <button
                  onClick={() => {
                    setCurrentScreen('dashboard');
                    window.history.pushState({}, '', '/dashboard');
                  }}
                  className="bg-blue-100 hover:bg-blue-200 text-blue-700 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                >
                  Dashboard
                </button>
              </div>
            </div>
            
            {/* Diagram Analysis Tool */}
            <DiagramAnalysisTool />
          </div>
        </div>
      )}

      {/* Student Info Form - authenticated users only */}
      {/* Student Info screen removed - test generation now happens directly from dashboard */}

      {/* Test Generation Loading Modal */}
      {isGeneratingQuestions && isAuthenticated && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="max-w-lg w-full">
            <div className="bg-white rounded-3xl shadow-2xl p-8 transform transition-all duration-300 scale-100">
              <div className="text-center">
                <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-6"></div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  🧠 Generating Your Personalized Test
                </h2>
                <p className="text-gray-600 mb-6">
                  Our AI is creating 60 unique questions tailored for {userProfile?.grade || user?.user_metadata?.grade}
                </p>
                
                {/* Progress indicator */}
                <div className="w-full bg-gray-200 rounded-full h-2 mb-6">
                  <div className="bg-blue-600 h-2 rounded-full animate-pulse" style={{width: '75%'}}></div>
                </div>
                
                {/* Informative messages */}
                <div className="space-y-3 mb-6">
                  <div className="flex items-center justify-center text-sm text-gray-600">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                    Analyzing curriculum standards for your grade level
                  </div>
                  <div className="flex items-center justify-center text-sm text-gray-600">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                    Creating questions across different difficulty levels
                  </div>
                  <div className="flex items-center justify-center text-sm text-gray-600">
                    <div className="w-2 h-2 bg-purple-500 rounded-full mr-2"></div>
                    Ensuring comprehensive topic coverage
                  </div>
                </div>
                
                <div className="text-sm text-gray-500 border-t pt-4">
                  <div className="font-medium mb-1">This usually takes 20-40 seconds</div>
                  <div>Please wait while we prepare your personalized assessment...</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Test Screen - only for authenticated users */}
      {currentScreen === 'test' && isAuthenticated && studentData && aiQuestions.length > 0 && (
        <AITestScreen 
          studentData={studentData} 
          aiQuestions={aiQuestions}
          onComplete={handleTestComplete} 
        />
      )}
      
      {/* Completion Screen - only for authenticated users */}
      {currentScreen === 'completion' && isAuthenticated && studentData && testResults && (
        <AITestCompletionScreen 
          studentData={studentData}
          results={testResults}
          onRetake={handleRetake}
          onExit={handleExit}
          onShowReport={() => setShowReportModal(true)}
        />
      )}
      
      {/* Report Modal */}
      {showReportModal && studentData && testResults && (
        <AIReportPreviewModal 
          studentData={studentData}
          results={testResults}
          onClose={() => setShowReportModal(false)}
        />
      )}

      {/* Authentication Modal */}
      {showAuthModal && (
        <AuthModal
          isOpen={showAuthModal}
          onClose={() => setShowAuthModal(false)}
          initialMode={authModalMode}
        />
      )}

      {/* Grade Collection Modal for Legacy Users */}
      <GradeCollectionModal
        isOpen={showGradeModal}
        onClose={closeGradeModal}
      />

      {/* Reset Password Modal */}
      {showResetPasswordModal && (
        <ResetPasswordPage
          onClose={() => {
            setShowResetPasswordModal(false);
            setCurrentScreen('landing');
            // Clear URL hash and navigate to landing
            window.history.pushState({}, '', '/');
          }}
          onSuccess={() => {
            setShowResetPasswordModal(false);
            setCurrentScreen('landing');
            setShowAuthModal(true);
            setAuthModalMode('login');
            // Clear URL hash and navigate to landing
            window.history.pushState({}, '', '/');
          }}
        />
      )}

      {/* Practice Session Launcher Screen */}
      {currentScreen === 'practice-launcher' && isAuthenticated && (
        <PracticeSessionLauncher
          onBack={handleBackFromPracticeLauncher}
          onStartSession={handlePracticeSessionStart}
        />
      )}

      {/* Practice Session Screen */}
      {currentScreen === 'practice-session' && isAuthenticated && activePracticeSession && (
        <PracticeSession
          sessionData={activePracticeSession}
          onComplete={handlePracticeSessionComplete}
          onBack={handleBackFromPracticeSession}
        />
      )}

      {/* Subscription Success Screen */}
      {currentScreen === 'subscription-success' && (
        <SubscriptionSuccess />
      )}

      {/* Subscription Cancel Screen */}
      {currentScreen === 'subscription-cancel' && (
        <SubscriptionCancel />
      )}
      
      {/* Redirect unauthenticated users trying to access protected screens */}
      {!isAuthenticated && ['test', 'completion', 'dashboard', 'practice-launcher', 'practice-session'].includes(currentScreen) && (
        <ProtectedRoute>
          <div>Protected content</div>
        </ProtectedRoute>
      )}
    </div>
  );
}

// Main App component with authentication wrapper
function App() {
  // Initialize LogRocket on app startup
  useEffect(() => {
    initializeLogRocket();
  }, []);

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
